function addStyleText(tex) {
  var newSS = document.createElement('style');
  newSS.innerHTML = tex;
  document.getElementsByTagName('head')[0].appendChild(newSS);
}

export const getListonDynamic = () => {
  const arrayListones = [
    { id: 1, colorText: '#fff', colorBack: '#ec2e20', cintaBack: '#a92920' },
    { id: 2, colorText: '#fff', colorBack: '#f58426', cintaBack: '#b15f1b' },
    {
      id: 3,
      colorText: '##11446d',
      colorBack: '#c2e6fa',
      cintaBack: '#0076ab',
    },
    { id: 4, colorText: '#fff', colorBack: '#6918d3', cintaBack: '#270554' },
    { id: 5, colorText: '#fff', colorBack: '#171616', cintaBack: '#000' },
    { id: 6, colorText: '#fff', colorBack: '#0056a6', cintaBack: '#14b0de' },
    { id: 7, colorText: '#fff', colorBack: '#e20177', cintaBack: '#9e0c59' },
  ];
  for (let i = 0; i < arrayListones.length; i++) {
    addStyleText(
      '.listonDinamico' +
        arrayListones[i].id +
        ' span {color: ' +
        arrayListones[i].colorText +
        ';background-color: ' +
        arrayListones[i].colorBack +
        ';}' +
        '.listonDinamico' +
        arrayListones[i].id +
        ' span::before {border-top: 3px solid ' +
        arrayListones[i].cintaBack +
        ';border-left: 3px solid ' +
        arrayListones[i].cintaBack +
        ';}' +
        '.listonDinamico' +
        arrayListones[i].id +
        ' span::after {border-right: 3px solid ' +
        arrayListones[i].cintaBack +
        ';border-top: 3px solid ' +
        arrayListones[i].cintaBack +
        ';}'
    );
  }
};
